import { Bar, BarChart, CartesianGrid, Tooltip, XAxis, YAxis } from "recharts";

// Bar chart data
const targetQuantity = [
    { name: "Jan", orders: 85 },
    { name: "Feb", orders: 65 },
    { name: "Mar", orders: 45 },
    { name: "Apr", orders: 35 },
];

const BarChartComponent = () => {
    return (
        <div className="card shadow-sm border-0">
            <div className="card-body">
                <h5 className="card-title">Target Quantity (In thousands)</h5>
                <BarChart width={350} height={300} data={targetQuantity}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Bar
                        dataKey="orders"
                        fill="#0d6efd"
                        radius={[6, 6, 0, 0]}
                    />
                </BarChart>
            </div>
        </div>
    );
};

export default BarChartComponent;
